'use client';

import { Button } from '@stone-payments/jade';
import { type ReactNode } from 'react';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';

type CopyButtonProps = {
    textToCopy: string
    children: ReactNode,
    onCopy?: () => void
  }

export  function CopyButton({textToCopy, children, onCopy}: CopyButtonProps) {
  const [, copy] = useCopyToClipboard()

  function handleCopy() {
    copy(textToCopy)
    onCopy?.()
  }

  return (
    <Button className="w-full" onClick={handleCopy} icon="action-copy" size="medium">
      {children}
    </Button>
  )
}
